import { BasePlugin } from '../base'
import mdcDialog from './mdc-dialog.vue'

export { mdcDialog }

export default BasePlugin({
  mdcDialog
})
